import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

type Props = {
  sport: Sport;
};
export const useCommonCardPointsBalance = ({ sport }: Props) => {
  const { currentUser } = useCurrentUserContext();
  const balance = {
    [Sport.NBA]: currentUser?.nbaCommonCardPoints || 0,
    [Sport.FOOTBALL]: currentUser?.footballCommonCardPoints || 0,
    [Sport.BASEBALL]: currentUser?.baseballCommonCardPoints || 0,
  }[sport];
  return {
    commonCardPointsBalance: balance,
  };
};
